import {useSelector} from "react-redux";

// Returns a locale to use when fetching Seanet VOD
// seanetLocale is either already set in state, or is mapped from the language of the app
// backupLocale is always mapped from the default language of the app, to ignore if a user changed it

export const useSeanetLocale = () => {
    const mapLangToVodLocale = (lang) => {
        switch (lang) {
            case "en":
                return "en_US"
            case "de":
                return "de_DE"
            case "es":
                return "es_ES"
            default:
                return "en_US"
        }
    }

    const profileDefaultLang = useSelector(state => state.configuration.hubSettings.languages[0]?.code);
    const lang = useSelector(state => state.i18nState.lang);
    const locale = useSelector(state => state.seanetVod.seanetLocale);

    return {
        seanetLocale: locale ? locale : mapLangToVodLocale(lang),
        backupLocale: mapLangToVodLocale(profileDefaultLang)
    };
}